import { useLayoutEffect, useRef } from "react";

import { BannerContent } from "./banner-content";
import { useHubBanner } from "./use-hub-banner";

export const HubBanner = () => {
  const { data: banner, isLoading, isError } = useHubBanner();
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) {
      document.documentElement.style.setProperty("--hub-banner-height", "0px");
      return;
    }

    const setVar = () => {
      document.documentElement.style.setProperty(
        "--hub-banner-height",
        `${el.offsetHeight}px`,
      );
    };

    setVar();
    const observer = new ResizeObserver(setVar);
    observer.observe(el);

    return () => {
      observer.disconnect();
      document.documentElement.style.setProperty("--hub-banner-height", "0px");
    };
  }, [banner]);

  if (isLoading || isError || !banner) {
    return null;
  }

  return (
    <div ref={containerRef} className="fixed left-0 right-0 top-0 z-40">
      <BannerContent content={banner.content} />
    </div>
  );
};
